import { defineComponent, toRef, resolveComponent, openBlock, createBlock, withCtx, renderSlot, createElementBlock, Fragment, renderList } from 'vue';
import { r as re } from '../OrAutocompleteV3-8c6de221.js';
import { OrCheckboxTreeV3 as script$1 } from '../or-checkbox-tree-v3/index.js';
import { OrFormGroupV3 as script$2, FormGroupDirection } from '../or-form-group-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';
import '../or-checkbox-v3/index.js';

var script = defineComponent({
  name: 'OrCheckboxGroup',
  components: {
    OrCheckboxTree: script$1,
    OrFormGroup: script$2
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: () => FormGroupDirection.Vertical
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const proxyModelValue = re(toRef(props, 'modelValue'), context.emit);
    return {
      proxyModelValue
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrCheckboxTree = resolveComponent("OrCheckboxTree");
  const _component_OrFormGroup = resolveComponent("OrFormGroup");
  return openBlock(), createBlock(_component_OrFormGroup, {
    label: _ctx.label,
    error: _ctx.error,
    hint: _ctx.hint,
    disabled: _ctx.disabled,
    direction: _ctx.direction
  }, {
    addon: withCtx(() => [renderSlot(_ctx.$slots, "addon")]),
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, option => {
      return openBlock(), createBlock(_component_OrCheckboxTree, {
        key: option.value,
        modelValue: _ctx.proxyModelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.proxyModelValue = $event),
        item: option,
        disabled: _ctx.disabled || option.disabled,
        readonly: _ctx.readonly || option.readonly,
        collapsible: option.collapsible,
        expanded: option.expanded
      }, null, 8 /* PROPS */, ["modelValue", "item", "disabled", "readonly", "collapsible", "expanded"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["label", "error", "hint", "disabled", "direction"]);
}

script.render = render;
script.__file = "src/components/or-checkbox-group-v3/OrCheckboxGroup.vue";

export { script as OrCheckboxGroupV3 };
